<template>
  <div>
    <div class="portlet light">
      <div class="module-name">{{ title }}</div>
      <div class="portlet-title tabbable-line">
        <div class="caption">
          <i class="icon-globe font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">{{ title }}</span>
        </div>
      </div>
      <div class="portlet-body">
        <spinner v-if="showLoading"></spinner>
        <transition name="fade" v-if="!showLoading">
          <ul class="list-group" v-if="showList">
            <li class="list-group-item" v-for="(form, index) in forms"
                :class="{'open': isParent(form.data)}"
                v-if="showForm(form)">
              <collapse :selected="false">
                <div class="collapsible-header" slot="collapsible-header">
                  <h4>{{ form.name }} ({{ form.data.length }} record{{ (form.data.length !== 1) ? 's' : '' }})</h4>
                  <div class="actions">
                    <button class="btn green"
                            v-bind:disabled="!form.multiple_entries && (form.data.length !== 0)"
                            @click.stop="fillForm(index, form.id)"
                            v-if="!form.read_only">
                      <i class="fa fa-check-square-o" aria-hidden="true"></i>
                      Complete Form
                    </button>

                    <button class="btn default btn-show-completed-forms mt-ladda-btn ladda-button"
                            data-style="expand-left"
                            type="button"
                            :disabled="form.data.length === 0"
                            @click.stop.prevent="showFormsTables.includes(form.id, $event) ? hideCompletedFormsTable(form.id) : showCompletedFormsTable(form.id, $event)">
                      <span class="ladda-label">{{ showFormsTables.includes(form.id) ? 'Hide all' : 'Show all' }}</span>
                    </button>
                  </div>
                </div>
                <div class="collapsible-body" slot="collapsible-body">
                  <h4 v-if="form.data.length === 0">0 records found</h4>
                  <template v-if="showFormsTables.includes(form.id)">
                    <vue-good-table v-if="form.hasOwnProperty('results')"
                                    :columns="convertVueTableDateColumnsToLeftAlign(form.results.columns)"
                                    :rows="convertVueTableRowsArrayValueToPreviewNotAvailableString(form.results.rows)"
                                    :sort-options="sortOptions"
                                    :globalSearch="false"
                                    :paginate="false"
                                    styleClass="table table-bordered show-all-results vgt-table"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'before'"><a @click="editForm(props.index, form.id, props.row.id)">Edit</a></span>
                        <span v-if="props.column.type === 'date'">{{ props.row[props.column.field] }}</span>
                        <span v-else-if="props.column.field.startsWith('file-')">
                          <a v-for="file in props.row[props.column.field]"
                             :href="getFileUrl(props.column.field, file)"
                             target="_blank">
                            {{ file.name }}
                          </a>
                        </span>
                        <span v-else v-html="props.formattedRow[props.column.field] + ''"></span>
                      </template>
                    </vue-good-table>
                  </template>
                  <template v-else>
                    <div class="mt-comments row">
                      <div class="mt-comment" v-for="(record, index) in form.data"
                           :data-id="record.id"
                           :class="{'active': isSelected(record.id)}">
                        <div class="mt-comment-body">
                          <div class="mt-comment-info">
                            <span class="mt-comment-author"> {{ form.name }} </span>
                            <span class="mt-comment-date"> {{ record.created_date.date | formatDate }} </span>
                          </div>
                          <div class="mt-comment-text"> Completed By: <b>{{ record.creator }}</b></div>
                          <div class="mt-comment-details">
                            <ul class="mt-comment-actions">
                              <li>
                                <a @click="editForm(index, form.id, record.id)">Edit</a>
                              </li>
                              <li v-if="user.access > 2 && !forceReadOnly">
                                <a @click="removeFormModal(record.id)">Delete</a>
                              </li>
                              <li>
                                <a @click="printPage('/print/form/' + record.id)">Print</a>
                              </li>
                              <li v-if="!forceReadOnly">
                                <a @click="duplicateForm(record.id)">Duplicate</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </collapse>
            </li>
          </ul>

          <div v-else id="widgetForm">
            <vue-form-render ref="formRender"
                             :schema="currentForm.schema"
                             :conditions="currentForm.conditions"
                             :update-conditions="currentForm.updateConditions"
                             :hideValues="currentForm.hide_values"
                             :calculations="currentForm.calculations"
                             :validation-conditions="currentForm.extra_validation_rules"
                             :values="currentForm.values"
                             :date-format="user.date_format"
                             :user-access-level="user.access"
                             :lockform="forceReadOnly"
                             :form-previews="currentForm.form_previews"
                             name="widgetForm"
                             v-on:validation-failed="sendToParticipantMethod = null"
            >

            </vue-form-render>
            <button v-if="!forceReadOnly" class="btn green mt-ladda-btn ladda-button formSave"
                    data-style="expand-left" type="button" @click.prevent="onSubmit()">
              <span class="ladda-label">Save</span>
            </button>

            <button v-if="showSendToParticipantButton()" :disabled="!sendToParticipantButtonEnabled()" class="btn default mt-ladda-btn ladda-button formSave"
                    data-style="expand-left" type="button" @click.prevent="displaySendModal()">Send to {{ participantSingularName }} and Save</button>
            <button type="button" aria-hidden="true" class="btn default" @click.prevent="cancel"> Cancel</button>
            <div class="activity-info-container">
              <h4 v-if="currentForm.info.length != 0" class="activity-info">ACTIVITY LOGGING</h4>
              <span v-if="currentForm.info.created_date != null">Completed By: <b>{{ currentForm.info.creator }}</b> at {{ currentForm.info.created_date.date | formatDate }}<br></span>
              <div v-if="!isEqual(currentForm.info.created_date, currentForm.info.updated_date)">
                <span v-html="getEditor(currentForm.info)"></span>
              </div>
              <span></span>
              <span v-if="(currentForm.info.created_date != null) && !['organization_general','organization_organization'].includes(currentForm.module_key)" v-html="getCase(currentForm.info)"></span>
            </div>
          </div>
        </transition>
      </div>
      <div class="clearfix"></div>
    </div>
    <confirmation-modal
      id="remove_modal"
      title="DELETE FORM"
      question="Are you sure you would like to delete this form?"
      @confirmed="removeForm(currentDelete)"
    />
    <send-to-participant-modal
      v-if="displaySendToParticipantModal"
      v-on:send="sendToParticipantAndSave($event)"
      v-on:cancel="cancelSendToParticipant"
      v-on:display="displaySendToParticipantModal = $event"
    ></send-to-participant-modal>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import _ from 'lodash';
import {HTTP, ERROR, URL, getUserInfo} from '@/http-common';
import Collapse from '@/components/Collapse';
import VueFormRender from '@/components/formbuilder/VueFormRender';
import Spinner from '@/components/Spinner';
import {EventBus} from '@/event-bus.js';
import SendToParticipantModal from "./formRender/SendToParticipantModal";
import ConfirmationModal from "@/components/modals/ConfirmationModal";
import {QueryParam} from "../../enums/queryParam";
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  props: ['type', 'history', 'sortByName','forceReadOnly'],
  mixins: [
    participantDisplayName
  ],
  data() {
    return {
      participantId: this.$route.params.id,
      currentDelete: '',
      currentFormId: '',
      currentForm: {
        name: '',
        schema: [],
        conditions: [],
        updateConditions: [],
        calculations: [],
        values: [],
        hide_values: [],
        info: [],
        module_key: null,
        share_with_participant: false
      },
      showLoading: true,
      forms: [],
      fillFormId: null,
      currentDataId: null,
      showFormsTables: [],
      fileToken: localStorage.getItem('id_token'),
      titles: {
        assessment_outcomes: 'Assessment and Outcomes',
        activities_services: 'Activities and Services',
        organization_organization: 'Organization Forms',
        organization_general: 'General Forms'
      },
      savedDataId: null,
      sendToParticipantMethod: null,
      displaySendToParticipantModal: false,
      sortOptions: {
        enabled: true
      }
    }
  },

  components: {
    Collapse,
    VueFormRender,
    SendToParticipantModal,
    ConfirmationModal,
    Spinner,
  },

  mounted() {
    if (this.shouldEditBeOpened){
      this.openEditForm()
    } else {
      this.getData();
    }
    const self = this;
    EventBus.$on('cancel', () => {
      self.runCancel()
    });
  },

  computed: {
    ...mapGetters({
      participant: 'getParticipant',
      user: 'getUser'
    }),
    shouldEditBeOpened(){
      return !!this.$route.query.open && this.$route.query.open === 'true';
    },
    showList() {
      return this.fillFormId === null;
    },
    title() {
      return this.titles[this.type];
    }
  },

  methods: {
    convertVueTableDateColumnsToLeftAlign(columns){
      if (!Array.isArray(columns)) {
        return columns
      }

      return columns.map(column => {
        if (column.type === 'date') {
          column.tdClass = 'text-left'
          column.thClass = 'text-left'
        }
        return column
      });
    },
    convertVueTableRowsArrayValueToPreviewNotAvailableString(rows) {
      if (!Array.isArray(rows)) {
        return rows
      }

      return rows.map(row => {
        const formattedObject = {};

        for (const field in row) {
          if (field.startsWith('file-') && row[field]) {
            try {
              formattedObject[field] = JSON.parse(row[field]);
            } catch (e) {
              formattedObject[field] = row[field]
            }
          } else if (Array.isArray(row[field])) {
            formattedObject[field] = 'Preview not available'
          } else {
            formattedObject[field] = row[field]
          }
        }
        return formattedObject
      });
    },
    getFileUrl: function (fieldName, value) {
      return URL +'/form/download/file/'+ fieldName.split('-')[1]+'_'+value.file+'?token='+this.fileToken;
    },
    runCancel: _.debounce(function () {
      this.cancel();
    }, 200),
    printPage(url) {
      window.open(url, 'Print', 'left=0, top=0, width=1200, height=500, toolbar=0, resizable=0');
    },
    displaySendModal() {
      this.displaySendToParticipantModal = true;
    },
    onSubmit() {
      this.$refs.formRender.submit().then(results => {
        if (results.isValid) {
          let loadingButton = Ladda.create(document.querySelector('.ladda-button.formSave'));
          loadingButton.start();

          this.showLoading = true;

          const formData = new FormData();

          this.showFormsTables = [];

          let allData = {
            data: results.fields,
            module: this.type,
            participant_user_id: this.participantId,
            form_id: this.currentFormId,
            data_id: this.currentDataId,
          };

          if (this.sendToParticipantMethod !== null) {
            allData.skip_activity_feed = true;
          }

          allData.assignment_id = this.$route.params.historyid !== undefined ? this.$route.params.historyid : null

          formData.append('data', JSON.stringify(allData));
          results.files.forEach((file, index) => {
            formData.append(file.field + '-' + index, file.file);
          })


          let endpoint = '/form/update-values';

          if (!this.currentDataId) {
            endpoint = '/form/create-values'
          }

          HTTP.post(endpoint, formData).then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.savedDataId = response.data.data.data_id;
              this.$notify(response.data.data.message);
              this.cancel();

              if(this.sendToParticipantMethod !== null) {
                this.sendToParticipant();
              }
            }
          }).catch(err => {
            this.showLoading = false;
            this.$notify({
              type: 'error',
              text: err.response.data.message
            });
            console.log(err);
          }).finally(() => {
            this.showLoading = false;
            loadingButton.stop();
          });
        }
      })
    },

    getData() {
      this.showLoading = true;
      let history = this.$route.params.historyid !== undefined ? this.$route.params.historyid : null
      HTTP.post(`/form/grouped`, {module: this.type, element_id: this.participantId, assignment_id: history})
        .then(response => {
          ERROR(response);
          if (response.data.status === 'success') {

            this.forms = response.data.data;

            if (this.forceReadOnly) {
              this.forms = response.data.data.map((item) => {
                item.read_only = true;
                return item;
              });
            }

            if (this.sortByName) {
              this.forms = _.orderBy(this.forms, [item => item.name.toLowerCase()], ['asc'])
            }

            this.showLoading = false;
            _.delay(function () {
              $('.list-group-item.open .collapse-header').trigger('click');
            }, 500);

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEditor(data) {
      if (data.editor != null)
        return 'Modified By: <b>' + data.editor + '</b> at ' + this.$options.filters.formatDate(data.updated_date.date);
    },
    getCase(data) {
      let str = 'Case Manager: <b>' + (data.case_manager || 'Unassigned' )  + '</b>';

      if (data.secondary_case_manager !== null) {
        str += ', <b>' + data.secondary_case_manager + '</b>';
      }

      return str;
    },
    fillForm(idx, id) {
      this.fillFormId = idx;
      this.currentFormId = id;
      this.showLoading = true;

      let request = {id: id, participant_user_id: this.participantId};

      // If its assignment history, pull data for shared fields from historical form data, not current one (pass assignment id to do that)
      if (this.history && this.$route.params.historyid){
        request.assignment_id = this.$route.params.historyid
      }

      HTTP.post(`/form/get`, request)
        .then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.currentForm.name = response.data.data.name;
            this.currentForm.schema = JSON.parse(response.data.data.data);
            this.currentForm.conditions = JSON.parse(response.data.data.conditionals);
            this.currentForm.updateConditions = JSON.parse(response.data.data.update_conditionals);
            this.currentForm.calculations = JSON.parse(response.data.data.calculations);
            this.currentForm.extra_validation_rules = JSON.parse(response.data.data.extra_validation_rules);
            this.currentForm.hide_values = JSON.parse(response.data.data.hide_values);
            this.currentForm.share_with_participant = response.data.data.share_with_participant;
            this.currentForm.values = response.data.data.values;
            this.currentForm.form_previews = response.data.data.form_previews;
            this.showLoading = false;
          }
        })
        .catch(err => {
          console.log(err);
        }).then(() => {
        this.showFormsTables = [];
      });
    },
    removeFormModal(id) {
      $('#remove_modal').modal('show');
      this.currentDelete = id;
    },
    removeForm(id) {
      this.showLoading = true;
      HTTP.post(`/forms/data/delete`, {data_id: id})
        .then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.showLoading = false;
            this.getData();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    duplicateForm(id) {
      this.showLoading = true;
      HTTP.post(`/forms/data/duplicate`, {data_id: id})
        .then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.showLoading = false;
            this.getData();
          }
        })
        .catch(err => {
          console.log(err);
        });

    },
    editForm(idx, formId, id) {
      this.fillFormId = idx;
      this.currentFormId = formId;
      this.currentDataId = id;
      this.showLoading = true;

      return HTTP.post(`/form/data`, {data_id: id}).then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          this.currentForm.name = response.data.data.form.name;
          this.currentForm.schema = JSON.parse(response.data.data.form.data);
          this.currentForm.conditions = JSON.parse(response.data.data.form.conditionals);
          this.currentForm.updateConditions = JSON.parse(response.data.data.form.update_conditionals);
          this.currentForm.calculations = JSON.parse(response.data.data.form.calculations);
          this.currentForm.extra_validation_rules = JSON.parse(response.data.data.form.extra_validation_rules);
          this.currentForm.hide_values = JSON.parse(response.data.data.form.hide_values);
          this.currentForm.module_key = response.data.data.form.module_key;
          this.currentForm.values = response.data.data.values;
          this.currentForm.info = response.data.data.form_data;
          this.currentForm.share_with_participant = response.data.data.form.share_with_participant;
          this.currentForm.shared_form_status = response.data.data.shared_form_status;
          this.currentForm.form_previews = response.data.data.form_previews;
          this.showLoading = false;
        }
        return response
      })
        .catch(err => {
          //this.button.stop();
          console.log(err);
        });

    },

    openEditForm(){
      this.editForm(true, null, this.$route.params.dataid ? this.$route.params.dataid : this.$route.query[QueryParam.FORM_DATA_ID]).then(response=>{
        this.currentFormId = response.data.data.form.id
      })
    },

    isEqual(first, second) {
      return JSON.stringify(first) === JSON.stringify(second);
    },

    isSelected(id) {
      return (id == this.$route.params.dataid);
    },

    isParent(data) {
      let self = this;
      return data.filter(form => {
        return form.id == self.$route.params.dataid;
      }).length
    },

    cancel() {
      this.fillFormId = null;
      this.currentForm = {
        name: '',
        schema: [],
        conditions: [],
        calculations: [],
        values: [],
        info: [],
        form_previews: []
      };
      this.currentDataId = null;
      this.showFormsTables = [];
      this.getData();
    },

    showCompletedFormsTable(formId, event) {
      let buttonEl = event.target;
      let laddaButton = Ladda.create(buttonEl.closest('button'));
      laddaButton.start();
      let history = this.$route.params.historyid !== undefined ? this.$route.params.historyid : null;
      HTTP.get('/forms/preview', {
        params: {
          module: this.type,
          element_id: this.participantId,
          assignment_id: history,
          form_id: formId
        }
      }).then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          let form = this.forms.find(x => x.id === formId);
          form.results = response.data.data;
          form.results.columns.unshift({
            'label': 'Entry',
            'field': 'before'
          });

          if (form.results != null) {

            // Transform date_created and modified from objects to strings for vue-good-table sort to work
            form.results.rows.map(row => {
              if (row['_date_created']){
                // set default order by to date_created if exists
                this.sortOptions.initialSortBy = {field: '_date_created', type: 'desc'}

                row['_date_created'] = this.$options.filters.formatDateModal(row['_date_created'].date)
              }
              if (row['_date_modified']) {
                row['_date_modified'] = this.$options.filters.formatDateModal(row['_date_modified'].date)
              }
            })

            let cols = [];
            form.results.columns.map(obj => {
              let dateFormat = getUserInfo('date_format').replace(/D/g, 'd').replace(/Y/g, 'y')

              if (obj.field.search('-') !== -1) {
                let type = obj.field.split('-')[0];
                if (type === 'date') {
                  obj.type = type;
                  obj.dateInputFormat = dateFormat;
                  obj.dateOutputFormat = dateFormat;
                  obj.formatFn = function (value) {
                    return value != null ? value : null
                  }
                }

              }

              // Transform date_created and modified from type objects to type date for vue-good-table sort to work
              if (obj.field === '_date_created' || obj.field === '_date_modified'){
                obj.type = 'date';
                obj.dateInputFormat = dateFormat;
                obj.dateOutputFormat = dateFormat;
                obj.formatFn = function (value) {
                  return value != null ? value : null
                }
              }

              cols.push(obj);
            });
            form.results.columns = cols;
          }

          this.showFormsTables.indexOf(formId) === -1 ? this.showFormsTables.push(formId) : '';

          _.delay(function () {
            let collapseItem = $(buttonEl).closest('.collapse-item');
            if (!collapseItem.hasClass('is-active')) {
              collapseItem.find('.collapse-header').trigger('click');
            }
          }, 500);
        }
      }).catch(err => {
        console.log(err);
      }).then(() => {
        laddaButton.stop();
      });
    },
    hideCompletedFormsTable(formId) {
      let index = this.showFormsTables.indexOf(formId);
      if (index > -1) {
        this.showFormsTables.splice(index, 1);
      }
    },
    showForm(form) {
      if(['organization_organization', 'organization_general'].includes(this.type) && form.publish) {
        return true;
      }

      if (this.user.organizations[0].accountType !== 'program') {
        return form.publish || form.data.length != 0
      }

      if(form.publish && form.data.length != 0) {
        return true;
      }

      if(form.read_only && form.data.length != 0) {
        return true;
      }

      if(!this.participant.profile.hasOwnProperty('programs')) {
        return false;
      }

      let participantPrograms = this.participant.profile.programs;
      let formPrograms = form.programs;

      if(!formPrograms.length) {
        return false;
      }

      if(!participantPrograms.length) {
        return false;
      }

      if(participantPrograms.filter(value => formPrograms.includes(parseInt(value))).length) {
        if(!form.publish && !form.data.length) {
          return false;
        }
        return true;
      }

      return false;
    },
    showSendToParticipantButton() {
      return !!this.currentForm.share_with_participant;
    },
    sendToParticipantButtonEnabled() {
      if (!this.currentForm.hasOwnProperty('shared_form_status')) {
        return true;
      }

      if (this.currentForm.shared_form_status === 'completed') {
        return false;
      }

      return true;
    },
    cancelSendToParticipant() {
      this.sendToParticipantMethod = null;
    },
    sendToParticipantAndSave(communicationChannel) {
      this.sendToParticipantMethod = communicationChannel;
      this.onSubmit();
    },
    sendToParticipant() {
      this.showLoading = true;
      HTTP.post('/shared-forms/send-to-participant', {
        form_data_id: this.savedDataId,
        participant_id: this.participant.id,
        via: this.sendToParticipantMethod,
      }).then(response => {
        ERROR(response);
        this.showLoading = false;
        if (response.data.status === 'success') {
          this.$notify(response.data.data.message);
          $('#send-to-participant-modal').modal('hide');
        } else {
          this.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        this.$emit('refresh-communication-notes', true);
      }).catch(err => {
        this.$notify({
          type: 'error',
          text: err.response.data.message
        });
        this.$emit('refresh-communication-notes', true);
      });
    }
  },
  watch: {
    '$route.params.id': function () {
      this.participantId = this.$route.params.id;
    },
    'title': function () {
      this.getData() // reload assignment history modify forms
    }
  }
}
</script>

<style>
table.show-all-results {
  padding-bottom: 15px;
}
</style>

<style scoped lang="scss">
.list-group-item {
  padding: 0 15px;
  margin-bottom: 10px;
}

.collapsible-header {
  h4 {
    padding: 10px 0;
    display: inline-block;
    width: calc(100% - 300px);
  }

  .actions {
    float: right;
    button {
      margin-top: 14px;
    }
  }
}

.mt-comments .mt-comment .mt-comment-body {
  padding-left: 5px;
}

.collapsible-body {
  margin-top: -20px;
}

.good-table {
  margin-bottom: 15px;
}

@media only screen and (max-width: 991px) {
  .mt-comments .mt-comment .mt-comment-body .mt-comment-details .mt-comment-actions {
    display: block;
  }
}

@media only screen and (max-width: 650px) {
  .collapsible-header {
    .actions {
      float: none;
      display: flex;
      justify-content: space-between;
      button {
        flex-grow: 1;
        flex-basis: 0;
        margin-bottom: 15px;
        margin-top: 0px;
      }
      button:first-child {
        margin-right: 10px;
      }
    }

    h4 {
      width: 100%;
    }
  }

  .mt-comments .mt-comment .mt-comment-body .mt-comment-details .mt-comment-actions {
    float: left;
    margin: 10px 0;
  }

  .mt-comments .mt-comment .mt-comment-body .mt-comment-info .mt-comment-date {
    float: left;
    margin-bottom: 10px;
  }

  .mt-comments .mt-comment .mt-comment-body .mt-comment-info span {
    display: block;
    float: initial !important;
  }
}

.mt-comments .mt-comment.active .mt-comment-body .mt-comment-details .mt-comment-actions {
  display: inline-block;
}

.mt-comments .mt-comment.active {
  background: #f9f9f9;
}

.activity-info-container span {
  font-size: 12px;
}

.activity-info {
  margin-top: 40px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// FormCRUD.vue?6c4cecc2